module.exports = __webpack_public_path__ + "static/img/img1.612ccb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1.png
// module id = fgq6
// module chunks = 1